<template>
  <div>
    <span
      v-if="showIcon"
      class="cursor-pointer text-main-primary"
      @click="showInformationGuide"
    ><InfoRoundedSmall /></span>

    <ModalComponent
      name="PurchaseInfoGuideModal"
      class="overflow-y-auto"
      :width="700"
      height="auto"
      :adaptive="true"
      :scrollable="true"
      :click-to-close="true"
    >
      <div class="w-full px-8 py-4">
        <div class="flex w-full justify-between gap-2">
          <h1 class="mb-2 font-semibold text-main-primary">
            Guidance
          </h1>
          <button
            class="flex h-8 w-8 items-center justify-center rounded-md bg-gray-100 text-[#808080] outline-none"
            @click="hideInformationGuide"
          >
            <TimesSmall />
          </button>
        </div>
      </div>
      <hr class="mb-3">
      <div class="mb-6 px-8">
        <div class="text-gray-500">
          <h1 class="mb-2 font-semibold text-main-primary">
            Tracking Emissions? Know the Difference!
          </h1>
          <p class="text-xs">
            When it comes to tracking your organization's Scope 2 emissions,
            precision matters. You are required to calculate your Scope 2
            emissions using both methods, as specified by the GHG Protocol.
            There are two distinct approaches: Location-Based and Market-Based.
            It is advisable to provide data for both methods when applicable.
          </p>
        </div>

        <div class="my-3 text-gray-500">
          <h1 class="mb-2 font-semibold text-main-primary">
            Location-Based Method:
          </h1>
          <ul class="list-disc px-4 text-xs">
            <li>
              Calculates emissions based on the local grid area where your
              electricity usage occurs.
            </li>
            <li>
              Ideal for a broader view of emissions that considers the grid's
              actual carbon intensity.
            </li>
          </ul>
        </div>

        <div class="my-3 text-gray-500">
          <h1 class="mb-2 font-semibold text-main-primary">
            Market-Based Method
            <span
              class="mb-2 mr-2 w-fit rounded border border-yellow-300 bg-yellow-100 px-2.5 py-0.5 text-xs font-medium text-yellow-800"
            >
              Coming Soon</span>
          </h1>
          <ul class="list-disc px-4 text-xs">
            <li class="mb-2">
              Calculates emissions based on your electricity purchase
              agreements, like Renewable Energy Certificates (RECs), Power
              Purchase Agreements (PPA), Energy Attribute Certificates (EAC)
              etc.
            </li>
            <li class="mb-2">
              Choose this if you want to track emissions according to the
              specific sources you've committed to.
            </li>
            <li>
              If the market-based PurchaseInfo is lacking, use the same input as
              for the Location-Based (grid average) method.
            </li>
          </ul>
        </div>
        <div class="my-3 text-gray-500">
          <p class="mb-2 text-xs">
            To help us assist you better, please label your electricity-related
            data as indicated below in parenthesis:
          </p>
          <ul class="list-disc px-4 text-xs">
            <li>Meter A (Grid)</li>
            <li>Bill January (Grid)</li>
            <li>Meter C (Renewable)</li>
            <li>Electricity Bill (Renewable)</li>
          </ul>
          <p class="my-2 text-xs">
            This small change makes a big difference in accurately matching your
            data with the right emission factor!
          </p>
          <p class="text-xs">
            Choose wisely, and let's make a positive impact on our environment
            together.
          </p>
        </div>
      </div>
      <div class="flex justify-end gap-4 border-t bg-gray-100 px-8 py-3">
        <PrimaryButton @click="hideInformationGuide">
          Continue
        </PrimaryButton>
      </div>
    </ModalComponent>
  </div>
</template>

<script>
export default {
  name: 'PurchaseInfoGuideModal',

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },
    showIcon: {
      type: Boolean,
      default: true,
    },
  },

  data() {
    return {
      displayModal: this.showModal,
    }
  },

  watch: {
    showModal: {
      immediate: true,
      handler() {
        this.$modal.show('PurchaseInfoGuideModal')
      },
    },
    displayModal: {
      immediate: true,
      handler(newValue) {
        if (newValue) {
          this.$modal.show('PurchaseInfoGuideModal')
        }
      },
    },
  },

  methods: {
    showInformationGuide() {
      localStorage.setItem('visitedBeforeGuideModal', true)
      this.$modal.show('PurchaseInfoGuideModal')
    },

    hideInformationGuide() {
      this.displayModal = false
      this.$modal.hide('PurchaseInfoGuideModal')
    },
  },
}
</script>
